/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrackRouteImport } from './routes/track'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as PortfolioIdRouteImport } from './routes/portfolio.$id'
import { Route as PaymentResultRouteImport } from './routes/payment.result'
import { Route as PaymentFailedRouteImport } from './routes/payment.failed'
import { Route as OrderSummaryOrderIdRouteImport } from './routes/order-summary.$orderId'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as CheckoutFailedRouteImport } from './routes/checkout.failed'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminTrackingRouteImport } from './routes/admin.tracking'
import { Route as AdminSiteRouteImport } from './routes/admin.site'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminServicesRouteImport } from './routes/admin.services'
import { Route as AdminSeoRouteImport } from './routes/admin.seo'
import { Route as AdminReviewsRouteImport } from './routes/admin.reviews'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminQuotesRouteImport } from './routes/admin.quotes'
import { Route as AdminPortfolioRouteImport } from './routes/admin.portfolio'
import { Route as AdminPlansRouteImport } from './routes/admin.plans'
import { Route as AdminPaymentRouteImport } from './routes/admin.payment'
import { Route as AdminPartnerRouteImport } from './routes/admin.partner'
import { Route as AdminLegalRouteImport } from './routes/admin.legal'
import { Route as AdminInvoicesRouteImport } from './routes/admin.invoices'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AdminBookingsRouteImport } from './routes/admin.bookings'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminAbandonedCartsRouteImport } from './routes/admin.abandoned-carts'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountFavoritesRouteImport } from './routes/account.favorites'
import { Route as AdminTicketsIndexRouteImport } from './routes/admin.tickets.index'
import { Route as AdminServicesIndexRouteImport } from './routes/admin.services.index'
import { Route as AccountTicketsIndexRouteImport } from './routes/account.tickets.index'
import { Route as AccountOrdersIndexRouteImport } from './routes/account.orders.index'
import { Route as AdminTicketsTicketIdRouteImport } from './routes/admin.tickets.$ticketId'
import { Route as AdminSettingsTeamRouteImport } from './routes/admin.settings.team'
import { Route as AdminSettingsProfileRouteImport } from './routes/admin.settings.profile'
import { Route as AdminSettingsNotificationsRouteImport } from './routes/admin.settings.notifications'
import { Route as AdminSettingsIntegrationsRouteImport } from './routes/admin.settings.integrations'
import { Route as AdminSettingsAppearanceRouteImport } from './routes/admin.settings.appearance'
import { Route as AdminServicesSlugRouteImport } from './routes/admin.services.$slug'
import { Route as AccountTicketsNewRouteImport } from './routes/account.tickets.new'
import { Route as AccountTicketsTicketIdRouteImport } from './routes/account.tickets.$ticketId'
import { Route as AccountOrdersOrderIdRouteImport } from './routes/account.orders.$orderId'

const TrackRoute = TrackRouteImport.update({
  id: '/track',
  path: '/track',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteRoute = QuoteRouteImport.update({
  id: '/quote',
  path: '/quote',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesIndexRoute = ServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesSlugRoute = ServicesSlugRouteImport.update({
  id: '/services/$slug',
  path: '/services/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioIdRoute = PortfolioIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PortfolioRoute,
} as any)
const PaymentResultRoute = PaymentResultRouteImport.update({
  id: '/payment/result',
  path: '/payment/result',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentFailedRoute = PaymentFailedRouteImport.update({
  id: '/payment/failed',
  path: '/payment/failed',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderSummaryOrderIdRoute = OrderSummaryOrderIdRouteImport.update({
  id: '/order-summary/$orderId',
  path: '/order-summary/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => CheckoutRoute,
} as any)
const CheckoutFailedRoute = CheckoutFailedRouteImport.update({
  id: '/failed',
  path: '/failed',
  getParentRoute: () => CheckoutRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/auth/reset',
  path: '/auth/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrackingRoute = AdminTrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSiteRoute = AdminSiteRouteImport.update({
  id: '/site',
  path: '/site',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminServicesRoute = AdminServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeoRoute = AdminSeoRouteImport.update({
  id: '/seo',
  path: '/seo',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReviewsRoute = AdminReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuotesRoute = AdminQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPortfolioRoute = AdminPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentRoute = AdminPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPartnerRoute = AdminPartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLegalRoute = AdminLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientsRoute = AdminClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBookingsRoute = AdminBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAbandonedCartsRoute = AdminAbandonedCartsRouteImport.update({
  id: '/abandoned-carts',
  path: '/abandoned-carts',
  getParentRoute: () => AdminRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountFavoritesRoute = AccountFavoritesRouteImport.update({
  id: '/account/favorites',
  path: '/account/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTicketsIndexRoute = AdminTicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminServicesIndexRoute = AdminServicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminServicesRoute,
} as any)
const AccountTicketsIndexRoute = AccountTicketsIndexRouteImport.update({
  id: '/account/tickets/',
  path: '/account/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountOrdersIndexRoute = AccountOrdersIndexRouteImport.update({
  id: '/account/orders/',
  path: '/account/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTicketsTicketIdRoute = AdminTicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsTeamRoute = AdminSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsProfileRoute = AdminSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsNotificationsRoute =
  AdminSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsIntegrationsRoute =
  AdminSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsAppearanceRoute = AdminSettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminServicesSlugRoute = AdminServicesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AdminServicesRoute,
} as any)
const AccountTicketsNewRoute = AccountTicketsNewRouteImport.update({
  id: '/account/tickets/new',
  path: '/account/tickets/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountTicketsTicketIdRoute = AccountTicketsTicketIdRouteImport.update({
  id: '/account/tickets/$ticketId',
  path: '/account/tickets/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountOrdersOrderIdRoute = AccountOrdersOrderIdRouteImport.update({
  id: '/account/orders/$orderId',
  path: '/account/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRouteWithChildren
  '/contact': typeof ContactRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/plans': typeof PlansRoute
  '/portfolio': typeof PortfolioRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/quote': typeof QuoteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/track': typeof TrackRoute
  '/account/favorites': typeof AccountFavoritesRoute
  '/account/profile': typeof AccountProfileRoute
  '/admin/abandoned-carts': typeof AdminAbandonedCartsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/clients': typeof AdminClientsRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/legal': typeof AdminLegalRoute
  '/admin/partner': typeof AdminPartnerRoute
  '/admin/payment': typeof AdminPaymentRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/portfolio': typeof AdminPortfolioRoute
  '/admin/quotes': typeof AdminQuotesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reviews': typeof AdminReviewsRoute
  '/admin/seo': typeof AdminSeoRoute
  '/admin/services': typeof AdminServicesRouteWithChildren
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/site': typeof AdminSiteRoute
  '/admin/tracking': typeof AdminTrackingRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/reset': typeof AuthResetRoute
  '/checkout/failed': typeof CheckoutFailedRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/order-summary/$orderId': typeof OrderSummaryOrderIdRoute
  '/payment/failed': typeof PaymentFailedRoute
  '/payment/result': typeof PaymentResultRoute
  '/portfolio/$id': typeof PortfolioIdRoute
  '/services/$slug': typeof ServicesSlugRoute
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/account/orders/$orderId': typeof AccountOrdersOrderIdRoute
  '/account/tickets/$ticketId': typeof AccountTicketsTicketIdRoute
  '/account/tickets/new': typeof AccountTicketsNewRoute
  '/admin/services/$slug': typeof AdminServicesSlugRoute
  '/admin/settings/appearance': typeof AdminSettingsAppearanceRoute
  '/admin/settings/integrations': typeof AdminSettingsIntegrationsRoute
  '/admin/settings/notifications': typeof AdminSettingsNotificationsRoute
  '/admin/settings/profile': typeof AdminSettingsProfileRoute
  '/admin/settings/team': typeof AdminSettingsTeamRoute
  '/admin/tickets/$ticketId': typeof AdminTicketsTicketIdRoute
  '/account/orders/': typeof AccountOrdersIndexRoute
  '/account/tickets/': typeof AccountTicketsIndexRoute
  '/admin/services/': typeof AdminServicesIndexRoute
  '/admin/tickets/': typeof AdminTicketsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRouteWithChildren
  '/contact': typeof ContactRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/plans': typeof PlansRoute
  '/portfolio': typeof PortfolioRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/quote': typeof QuoteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/track': typeof TrackRoute
  '/account/favorites': typeof AccountFavoritesRoute
  '/account/profile': typeof AccountProfileRoute
  '/admin/abandoned-carts': typeof AdminAbandonedCartsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/clients': typeof AdminClientsRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/legal': typeof AdminLegalRoute
  '/admin/partner': typeof AdminPartnerRoute
  '/admin/payment': typeof AdminPaymentRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/portfolio': typeof AdminPortfolioRoute
  '/admin/quotes': typeof AdminQuotesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reviews': typeof AdminReviewsRoute
  '/admin/seo': typeof AdminSeoRoute
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/site': typeof AdminSiteRoute
  '/admin/tracking': typeof AdminTrackingRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/reset': typeof AuthResetRoute
  '/checkout/failed': typeof CheckoutFailedRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/order-summary/$orderId': typeof OrderSummaryOrderIdRoute
  '/payment/failed': typeof PaymentFailedRoute
  '/payment/result': typeof PaymentResultRoute
  '/portfolio/$id': typeof PortfolioIdRoute
  '/services/$slug': typeof ServicesSlugRoute
  '/account': typeof AccountIndexRoute
  '/admin': typeof AdminIndexRoute
  '/services': typeof ServicesIndexRoute
  '/account/orders/$orderId': typeof AccountOrdersOrderIdRoute
  '/account/tickets/$ticketId': typeof AccountTicketsTicketIdRoute
  '/account/tickets/new': typeof AccountTicketsNewRoute
  '/admin/services/$slug': typeof AdminServicesSlugRoute
  '/admin/settings/appearance': typeof AdminSettingsAppearanceRoute
  '/admin/settings/integrations': typeof AdminSettingsIntegrationsRoute
  '/admin/settings/notifications': typeof AdminSettingsNotificationsRoute
  '/admin/settings/profile': typeof AdminSettingsProfileRoute
  '/admin/settings/team': typeof AdminSettingsTeamRoute
  '/admin/tickets/$ticketId': typeof AdminTicketsTicketIdRoute
  '/account/orders': typeof AccountOrdersIndexRoute
  '/account/tickets': typeof AccountTicketsIndexRoute
  '/admin/services': typeof AdminServicesIndexRoute
  '/admin/tickets': typeof AdminTicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRouteWithChildren
  '/contact': typeof ContactRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/plans': typeof PlansRoute
  '/portfolio': typeof PortfolioRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/quote': typeof QuoteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/track': typeof TrackRoute
  '/account/favorites': typeof AccountFavoritesRoute
  '/account/profile': typeof AccountProfileRoute
  '/admin/abandoned-carts': typeof AdminAbandonedCartsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/clients': typeof AdminClientsRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/legal': typeof AdminLegalRoute
  '/admin/partner': typeof AdminPartnerRoute
  '/admin/payment': typeof AdminPaymentRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/portfolio': typeof AdminPortfolioRoute
  '/admin/quotes': typeof AdminQuotesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reviews': typeof AdminReviewsRoute
  '/admin/seo': typeof AdminSeoRoute
  '/admin/services': typeof AdminServicesRouteWithChildren
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/site': typeof AdminSiteRoute
  '/admin/tracking': typeof AdminTrackingRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/reset': typeof AuthResetRoute
  '/checkout/failed': typeof CheckoutFailedRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/order-summary/$orderId': typeof OrderSummaryOrderIdRoute
  '/payment/failed': typeof PaymentFailedRoute
  '/payment/result': typeof PaymentResultRoute
  '/portfolio/$id': typeof PortfolioIdRoute
  '/services/$slug': typeof ServicesSlugRoute
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/account/orders/$orderId': typeof AccountOrdersOrderIdRoute
  '/account/tickets/$ticketId': typeof AccountTicketsTicketIdRoute
  '/account/tickets/new': typeof AccountTicketsNewRoute
  '/admin/services/$slug': typeof AdminServicesSlugRoute
  '/admin/settings/appearance': typeof AdminSettingsAppearanceRoute
  '/admin/settings/integrations': typeof AdminSettingsIntegrationsRoute
  '/admin/settings/notifications': typeof AdminSettingsNotificationsRoute
  '/admin/settings/profile': typeof AdminSettingsProfileRoute
  '/admin/settings/team': typeof AdminSettingsTeamRoute
  '/admin/tickets/$ticketId': typeof AdminTicketsTicketIdRoute
  '/account/orders/': typeof AccountOrdersIndexRoute
  '/account/tickets/': typeof AccountTicketsIndexRoute
  '/admin/services/': typeof AdminServicesIndexRoute
  '/admin/tickets/': typeof AdminTicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/cart'
    | '/checkout'
    | '/contact'
    | '/forgot-password'
    | '/login'
    | '/plans'
    | '/portfolio'
    | '/privacy'
    | '/quote'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/track'
    | '/account/favorites'
    | '/account/profile'
    | '/admin/abandoned-carts'
    | '/admin/analytics'
    | '/admin/bookings'
    | '/admin/clients'
    | '/admin/invoices'
    | '/admin/legal'
    | '/admin/partner'
    | '/admin/payment'
    | '/admin/plans'
    | '/admin/portfolio'
    | '/admin/quotes'
    | '/admin/reports'
    | '/admin/reviews'
    | '/admin/seo'
    | '/admin/services'
    | '/admin/settings'
    | '/admin/site'
    | '/admin/tracking'
    | '/admin/users'
    | '/auth/reset'
    | '/checkout/failed'
    | '/checkout/success'
    | '/order-summary/$orderId'
    | '/payment/failed'
    | '/payment/result'
    | '/portfolio/$id'
    | '/services/$slug'
    | '/account/'
    | '/admin/'
    | '/services/'
    | '/account/orders/$orderId'
    | '/account/tickets/$ticketId'
    | '/account/tickets/new'
    | '/admin/services/$slug'
    | '/admin/settings/appearance'
    | '/admin/settings/integrations'
    | '/admin/settings/notifications'
    | '/admin/settings/profile'
    | '/admin/settings/team'
    | '/admin/tickets/$ticketId'
    | '/account/orders/'
    | '/account/tickets/'
    | '/admin/services/'
    | '/admin/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/cart'
    | '/checkout'
    | '/contact'
    | '/forgot-password'
    | '/login'
    | '/plans'
    | '/portfolio'
    | '/privacy'
    | '/quote'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/track'
    | '/account/favorites'
    | '/account/profile'
    | '/admin/abandoned-carts'
    | '/admin/analytics'
    | '/admin/bookings'
    | '/admin/clients'
    | '/admin/invoices'
    | '/admin/legal'
    | '/admin/partner'
    | '/admin/payment'
    | '/admin/plans'
    | '/admin/portfolio'
    | '/admin/quotes'
    | '/admin/reports'
    | '/admin/reviews'
    | '/admin/seo'
    | '/admin/settings'
    | '/admin/site'
    | '/admin/tracking'
    | '/admin/users'
    | '/auth/reset'
    | '/checkout/failed'
    | '/checkout/success'
    | '/order-summary/$orderId'
    | '/payment/failed'
    | '/payment/result'
    | '/portfolio/$id'
    | '/services/$slug'
    | '/account'
    | '/admin'
    | '/services'
    | '/account/orders/$orderId'
    | '/account/tickets/$ticketId'
    | '/account/tickets/new'
    | '/admin/services/$slug'
    | '/admin/settings/appearance'
    | '/admin/settings/integrations'
    | '/admin/settings/notifications'
    | '/admin/settings/profile'
    | '/admin/settings/team'
    | '/admin/tickets/$ticketId'
    | '/account/orders'
    | '/account/tickets'
    | '/admin/services'
    | '/admin/tickets'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/cart'
    | '/checkout'
    | '/contact'
    | '/forgot-password'
    | '/login'
    | '/plans'
    | '/portfolio'
    | '/privacy'
    | '/quote'
    | '/reset-password'
    | '/signup'
    | '/terms'
    | '/track'
    | '/account/favorites'
    | '/account/profile'
    | '/admin/abandoned-carts'
    | '/admin/analytics'
    | '/admin/bookings'
    | '/admin/clients'
    | '/admin/invoices'
    | '/admin/legal'
    | '/admin/partner'
    | '/admin/payment'
    | '/admin/plans'
    | '/admin/portfolio'
    | '/admin/quotes'
    | '/admin/reports'
    | '/admin/reviews'
    | '/admin/seo'
    | '/admin/services'
    | '/admin/settings'
    | '/admin/site'
    | '/admin/tracking'
    | '/admin/users'
    | '/auth/reset'
    | '/checkout/failed'
    | '/checkout/success'
    | '/order-summary/$orderId'
    | '/payment/failed'
    | '/payment/result'
    | '/portfolio/$id'
    | '/services/$slug'
    | '/account/'
    | '/admin/'
    | '/services/'
    | '/account/orders/$orderId'
    | '/account/tickets/$ticketId'
    | '/account/tickets/new'
    | '/admin/services/$slug'
    | '/admin/settings/appearance'
    | '/admin/settings/integrations'
    | '/admin/settings/notifications'
    | '/admin/settings/profile'
    | '/admin/settings/team'
    | '/admin/tickets/$ticketId'
    | '/account/orders/'
    | '/account/tickets/'
    | '/admin/services/'
    | '/admin/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRouteWithChildren
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRouteWithChildren
  ContactRoute: typeof ContactRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PlansRoute: typeof PlansRoute
  PortfolioRoute: typeof PortfolioRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  QuoteRoute: typeof QuoteRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  TrackRoute: typeof TrackRoute
  AccountFavoritesRoute: typeof AccountFavoritesRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AuthResetRoute: typeof AuthResetRoute
  OrderSummaryOrderIdRoute: typeof OrderSummaryOrderIdRoute
  PaymentFailedRoute: typeof PaymentFailedRoute
  PaymentResultRoute: typeof PaymentResultRoute
  ServicesSlugRoute: typeof ServicesSlugRoute
  AccountIndexRoute: typeof AccountIndexRoute
  ServicesIndexRoute: typeof ServicesIndexRoute
  AccountOrdersOrderIdRoute: typeof AccountOrdersOrderIdRoute
  AccountTicketsTicketIdRoute: typeof AccountTicketsTicketIdRoute
  AccountTicketsNewRoute: typeof AccountTicketsNewRoute
  AccountOrdersIndexRoute: typeof AccountOrdersIndexRoute
  AccountTicketsIndexRoute: typeof AccountTicketsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/track': {
      id: '/track'
      path: '/track'
      fullPath: '/track'
      preLoaderRoute: typeof TrackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote': {
      id: '/quote'
      path: '/quote'
      fullPath: '/quote'
      preLoaderRoute: typeof QuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/': {
      id: '/services/'
      path: '/services'
      fullPath: '/services/'
      preLoaderRoute: typeof ServicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/': {
      id: '/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/$slug': {
      id: '/services/$slug'
      path: '/services/$slug'
      fullPath: '/services/$slug'
      preLoaderRoute: typeof ServicesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/$id': {
      id: '/portfolio/$id'
      path: '/$id'
      fullPath: '/portfolio/$id'
      preLoaderRoute: typeof PortfolioIdRouteImport
      parentRoute: typeof PortfolioRoute
    }
    '/payment/result': {
      id: '/payment/result'
      path: '/payment/result'
      fullPath: '/payment/result'
      preLoaderRoute: typeof PaymentResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/failed': {
      id: '/payment/failed'
      path: '/payment/failed'
      fullPath: '/payment/failed'
      preLoaderRoute: typeof PaymentFailedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-summary/$orderId': {
      id: '/order-summary/$orderId'
      path: '/order-summary/$orderId'
      fullPath: '/order-summary/$orderId'
      preLoaderRoute: typeof OrderSummaryOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/checkout/failed': {
      id: '/checkout/failed'
      path: '/failed'
      fullPath: '/checkout/failed'
      preLoaderRoute: typeof CheckoutFailedRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/auth/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tracking': {
      id: '/admin/tracking'
      path: '/tracking'
      fullPath: '/admin/tracking'
      preLoaderRoute: typeof AdminTrackingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/site': {
      id: '/admin/site'
      path: '/site'
      fullPath: '/admin/site'
      preLoaderRoute: typeof AdminSiteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/services': {
      id: '/admin/services'
      path: '/services'
      fullPath: '/admin/services'
      preLoaderRoute: typeof AdminServicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seo': {
      id: '/admin/seo'
      path: '/seo'
      fullPath: '/admin/seo'
      preLoaderRoute: typeof AdminSeoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reviews': {
      id: '/admin/reviews'
      path: '/reviews'
      fullPath: '/admin/reviews'
      preLoaderRoute: typeof AdminReviewsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quotes': {
      id: '/admin/quotes'
      path: '/quotes'
      fullPath: '/admin/quotes'
      preLoaderRoute: typeof AdminQuotesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/portfolio': {
      id: '/admin/portfolio'
      path: '/portfolio'
      fullPath: '/admin/portfolio'
      preLoaderRoute: typeof AdminPortfolioRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payment': {
      id: '/admin/payment'
      path: '/payment'
      fullPath: '/admin/payment'
      preLoaderRoute: typeof AdminPaymentRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/partner': {
      id: '/admin/partner'
      path: '/partner'
      fullPath: '/admin/partner'
      preLoaderRoute: typeof AdminPartnerRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/legal': {
      id: '/admin/legal'
      path: '/legal'
      fullPath: '/admin/legal'
      preLoaderRoute: typeof AdminLegalRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invoices': {
      id: '/admin/invoices'
      path: '/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AdminInvoicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clients': {
      id: '/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AdminClientsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/bookings': {
      id: '/admin/bookings'
      path: '/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AdminBookingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/abandoned-carts': {
      id: '/admin/abandoned-carts'
      path: '/abandoned-carts'
      fullPath: '/admin/abandoned-carts'
      preLoaderRoute: typeof AdminAbandonedCartsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/favorites': {
      id: '/account/favorites'
      path: '/account/favorites'
      fullPath: '/account/favorites'
      preLoaderRoute: typeof AccountFavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tickets/': {
      id: '/admin/tickets/'
      path: '/tickets'
      fullPath: '/admin/tickets/'
      preLoaderRoute: typeof AdminTicketsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/services/': {
      id: '/admin/services/'
      path: '/'
      fullPath: '/admin/services/'
      preLoaderRoute: typeof AdminServicesIndexRouteImport
      parentRoute: typeof AdminServicesRoute
    }
    '/account/tickets/': {
      id: '/account/tickets/'
      path: '/account/tickets'
      fullPath: '/account/tickets/'
      preLoaderRoute: typeof AccountTicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/orders/': {
      id: '/account/orders/'
      path: '/account/orders'
      fullPath: '/account/orders/'
      preLoaderRoute: typeof AccountOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tickets/$ticketId': {
      id: '/admin/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/admin/tickets/$ticketId'
      preLoaderRoute: typeof AdminTicketsTicketIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/team': {
      id: '/admin/settings/team'
      path: '/team'
      fullPath: '/admin/settings/team'
      preLoaderRoute: typeof AdminSettingsTeamRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/profile': {
      id: '/admin/settings/profile'
      path: '/profile'
      fullPath: '/admin/settings/profile'
      preLoaderRoute: typeof AdminSettingsProfileRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/notifications': {
      id: '/admin/settings/notifications'
      path: '/notifications'
      fullPath: '/admin/settings/notifications'
      preLoaderRoute: typeof AdminSettingsNotificationsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/integrations': {
      id: '/admin/settings/integrations'
      path: '/integrations'
      fullPath: '/admin/settings/integrations'
      preLoaderRoute: typeof AdminSettingsIntegrationsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/appearance': {
      id: '/admin/settings/appearance'
      path: '/appearance'
      fullPath: '/admin/settings/appearance'
      preLoaderRoute: typeof AdminSettingsAppearanceRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/services/$slug': {
      id: '/admin/services/$slug'
      path: '/$slug'
      fullPath: '/admin/services/$slug'
      preLoaderRoute: typeof AdminServicesSlugRouteImport
      parentRoute: typeof AdminServicesRoute
    }
    '/account/tickets/new': {
      id: '/account/tickets/new'
      path: '/account/tickets/new'
      fullPath: '/account/tickets/new'
      preLoaderRoute: typeof AccountTicketsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/tickets/$ticketId': {
      id: '/account/tickets/$ticketId'
      path: '/account/tickets/$ticketId'
      fullPath: '/account/tickets/$ticketId'
      preLoaderRoute: typeof AccountTicketsTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/orders/$orderId': {
      id: '/account/orders/$orderId'
      path: '/account/orders/$orderId'
      fullPath: '/account/orders/$orderId'
      preLoaderRoute: typeof AccountOrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminServicesRouteChildren {
  AdminServicesSlugRoute: typeof AdminServicesSlugRoute
  AdminServicesIndexRoute: typeof AdminServicesIndexRoute
}

const AdminServicesRouteChildren: AdminServicesRouteChildren = {
  AdminServicesSlugRoute: AdminServicesSlugRoute,
  AdminServicesIndexRoute: AdminServicesIndexRoute,
}

const AdminServicesRouteWithChildren = AdminServicesRoute._addFileChildren(
  AdminServicesRouteChildren,
)

interface AdminSettingsRouteChildren {
  AdminSettingsAppearanceRoute: typeof AdminSettingsAppearanceRoute
  AdminSettingsIntegrationsRoute: typeof AdminSettingsIntegrationsRoute
  AdminSettingsNotificationsRoute: typeof AdminSettingsNotificationsRoute
  AdminSettingsProfileRoute: typeof AdminSettingsProfileRoute
  AdminSettingsTeamRoute: typeof AdminSettingsTeamRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsAppearanceRoute: AdminSettingsAppearanceRoute,
  AdminSettingsIntegrationsRoute: AdminSettingsIntegrationsRoute,
  AdminSettingsNotificationsRoute: AdminSettingsNotificationsRoute,
  AdminSettingsProfileRoute: AdminSettingsProfileRoute,
  AdminSettingsTeamRoute: AdminSettingsTeamRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

interface AdminRouteChildren {
  AdminAbandonedCartsRoute: typeof AdminAbandonedCartsRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminBookingsRoute: typeof AdminBookingsRoute
  AdminClientsRoute: typeof AdminClientsRoute
  AdminInvoicesRoute: typeof AdminInvoicesRoute
  AdminLegalRoute: typeof AdminLegalRoute
  AdminPartnerRoute: typeof AdminPartnerRoute
  AdminPaymentRoute: typeof AdminPaymentRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminPortfolioRoute: typeof AdminPortfolioRoute
  AdminQuotesRoute: typeof AdminQuotesRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminReviewsRoute: typeof AdminReviewsRoute
  AdminSeoRoute: typeof AdminSeoRoute
  AdminServicesRoute: typeof AdminServicesRouteWithChildren
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  AdminSiteRoute: typeof AdminSiteRoute
  AdminTrackingRoute: typeof AdminTrackingRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminTicketsTicketIdRoute: typeof AdminTicketsTicketIdRoute
  AdminTicketsIndexRoute: typeof AdminTicketsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAbandonedCartsRoute: AdminAbandonedCartsRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminBookingsRoute: AdminBookingsRoute,
  AdminClientsRoute: AdminClientsRoute,
  AdminInvoicesRoute: AdminInvoicesRoute,
  AdminLegalRoute: AdminLegalRoute,
  AdminPartnerRoute: AdminPartnerRoute,
  AdminPaymentRoute: AdminPaymentRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminPortfolioRoute: AdminPortfolioRoute,
  AdminQuotesRoute: AdminQuotesRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminReviewsRoute: AdminReviewsRoute,
  AdminSeoRoute: AdminSeoRoute,
  AdminServicesRoute: AdminServicesRouteWithChildren,
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  AdminSiteRoute: AdminSiteRoute,
  AdminTrackingRoute: AdminTrackingRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminTicketsTicketIdRoute: AdminTicketsTicketIdRoute,
  AdminTicketsIndexRoute: AdminTicketsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CheckoutRouteChildren {
  CheckoutFailedRoute: typeof CheckoutFailedRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
}

const CheckoutRouteChildren: CheckoutRouteChildren = {
  CheckoutFailedRoute: CheckoutFailedRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(
  CheckoutRouteChildren,
)

interface PortfolioRouteChildren {
  PortfolioIdRoute: typeof PortfolioIdRoute
}

const PortfolioRouteChildren: PortfolioRouteChildren = {
  PortfolioIdRoute: PortfolioIdRoute,
}

const PortfolioRouteWithChildren = PortfolioRoute._addFileChildren(
  PortfolioRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRouteWithChildren,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRouteWithChildren,
  ContactRoute: ContactRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PlansRoute: PlansRoute,
  PortfolioRoute: PortfolioRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  QuoteRoute: QuoteRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  TrackRoute: TrackRoute,
  AccountFavoritesRoute: AccountFavoritesRoute,
  AccountProfileRoute: AccountProfileRoute,
  AuthResetRoute: AuthResetRoute,
  OrderSummaryOrderIdRoute: OrderSummaryOrderIdRoute,
  PaymentFailedRoute: PaymentFailedRoute,
  PaymentResultRoute: PaymentResultRoute,
  ServicesSlugRoute: ServicesSlugRoute,
  AccountIndexRoute: AccountIndexRoute,
  ServicesIndexRoute: ServicesIndexRoute,
  AccountOrdersOrderIdRoute: AccountOrdersOrderIdRoute,
  AccountTicketsTicketIdRoute: AccountTicketsTicketIdRoute,
  AccountTicketsNewRoute: AccountTicketsNewRoute,
  AccountOrdersIndexRoute: AccountOrdersIndexRoute,
  AccountTicketsIndexRoute: AccountTicketsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
